<template>
  <PageTitle pageTitle="Beneficiários" mainTitle="Beneficiários" />

  <v-card class="mb-25 pingo-card">
    <div class="v-card-header d-flex">
      <h5 class="mb-2">Lista de Beneficiários</h5>

      <router-link
        class="default-btn pingo small"
        :to="{ name: 'NewUserPage', query: { type: 'BENEFICIARY' } }"
      >
        <i class="ri-add-fill"></i>
        Criar novo usuário
      </router-link>

      <!-- <p>Atualizado por último em {{ new Date().toLocaleString() }}</p> -->
    </div>

    <div class="pingo-table-content">
      <div class="v-elevation-z8 recentOrdersTable pingo-table">
        <v-data-table
          :headers="columns"
          :items="users"
          :loading="isLoadingUserBeneficiaries"
          :items-per-page="pagination.totalPerPage"
          hide-default-footer
        >
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-items-center ga-6" style="width: 150px">
              <router-link
                v-if="user.type == 'ADMIN'"
                :to="{
                  name: 'EditUserPage',
                  params: { id: item.userId },
                  query: { type: 'BENEFICIARY' },
                }"
              >
                <v-btn
                  class="text-capitalize"
                  color="primary-darken-3"
                  variant="tonal"
                >
                  Editar
                </v-btn>
              </router-link>

              <v-dialog width="auto" scrollable>
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn
                    class="text-capitalize"
                    color="red-darken-3"
                    variant="tonal"
                    v-bind="activatorProps"
                  >
                    Remover
                  </v-btn>
                </template>

                <template v-slot:default="{ isActive }">
                  <v-card class="py-0" title="Remover beneficiário">
                    <v-divider></v-divider>

                    <v-card-text class="px-4">
                      Tem certeza que deseja remover este beneficiário?
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-btn
                        class="text-capitalize"
                        @click="isActive.value = false"
                      >
                        Fechar
                      </v-btn>

                      <v-spacer></v-spacer>

                      <v-btn
                        class="text-capitalize"
                        color="red-darken-3"
                        variant="tonal"
                        @click="handleRemoveBeneficiary(item.userId)"
                      >
                        Remover
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </template>
              </v-dialog>
            </div>
          </template>

          <template v-slot:no-data> Não há nenhum beneficiário </template>

          <template v-slot:loading>
            <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
          </template>
        </v-data-table>

        <ItemsPerPage
          class="mt-15"
          :total_pages="pagination.totalPages"
          :total_items="pagination.totalElements"
          @update:pagination="(pagination: Pagination) => handleUpdatePageProps(pagination)"
        />
      </div>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref } from "vue";

import { useLoadingDialog } from "@/stores/loading.store";

import { useUser } from "@/composables/useUser";

import PageTitle from "@/components/Common/PageTitle.vue";

import ItemsPerPage from "@/components/Common/ItemsPerPage.vue";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Pagination } from "@/types/props/pagination";
import { useAuthStore } from "@/stores/auth.store";

export default defineComponent({
  name: "BeneficiariesPage",
  components: {
    PageTitle,
    ItemsPerPage,
  },
  setup() {
    const authStore = useAuthStore();
    const loadingStore = useLoadingDialog();

    const { columns, pagination, users, getAllBeneficiaries, deleteUserById } =
      useUser();

    const user: Ref = ref(authStore.getUser);

    const isLoadingUserBeneficiaries = ref(false);

    const fetchUserBeneficiariesData = async () => {
      try {
        isLoadingUserBeneficiaries.value = true;

        getAllBeneficiaries(
          pagination.value.currentPage,
          pagination.value.totalPerPage
        ).then(() => {
          isLoadingUserBeneficiaries.value = false;
        });
      } catch (error) {
        console.error("Erro ao buscar dados de beneficiários:", error);
      }
    };

    const handleRemoveBeneficiary = async (user_id: number) => {
      loadingStore.setLoading("Removendo beneficiário...");

      await deleteUserById(user_id);

      loadingStore.setLoadingOff();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleUpdatePageProps = async ({ page, size }: any) => {
      pagination.value.currentPage = page;
      pagination.value.totalPerPage = size;

      await fetchUserBeneficiariesData();
    };

    onMounted(async () => {
      await fetchUserBeneficiariesData();
    });

    return {
      user,
      columns,
      pagination,
      isLoadingUserBeneficiaries,
      users,
      handleUpdatePageProps,
      handleRemoveBeneficiary,
    };
  },
});
</script>
